module.exports = __webpack_public_path__ + "img/curioznica-aratare-1785-pagina-de-titlu-big.1950affa.png";